import * as requestFromServer from "./clearingAccountReportCrud";
import {
  callTypes,
  clearingAccountReportSlice
} from "./clearingAccountReportSlice";

const { actions } = clearingAccountReportSlice;

export const fetchClearingAccountReportList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .clearingAccountReportList({ queryParams })
    .then((response) => {
      const { count: totalCount, data: entities, Error } = response || {};
      if (Error) {
        dispatch(
          actions.catchError({ error: Error, callType: callTypes.list })
        );
      } else {
        dispatch(
          actions.clearingAccountReportListFetched({ totalCount, entities })
        );
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find Transactions";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const exportClearingAccountReportList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .clearingAccountReportExportList({ queryParams })
    .then((response) => {
      const { Error } = response || {};
      if (Error) {
        dispatch(
          actions.catchError({ error: Error, callType: callTypes.action })
        );
      } else {
        dispatch(
          actions.clearingAccountReportListExport({ xlsFilename: response })
        );
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find Transactions";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const fetchClearingAccountChartDetails = (queryParamsChart) => (
  dispatch
) => {
  dispatch(actions.startCall({ callType: callTypes.chart }));
  return requestFromServer
    .clearingAccountChartDetails({ queryParamsChart })
    .then((response) => {
      const { Revenue, transaction, Error } = response || {};
      if (Error) {
        dispatch(
          actions.catchError({ error: Error, callType: callTypes.chart })
        );
      } else {
        dispatch(
          actions.clearingAccountChartDetailsFetched({
            chartEntities: { Revenue, transaction }
          })
        );
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find Transactions";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
